import client from "../client";

const getTrainingTypes = () => client.get<any>("/training-types");
const create = (data: any) => client.post<any>("/training-types", data);
const update = (id: number, data: any) =>
  client.patch<any>(`/training-types/${id}`, data);
const remove = (id: number) => client.delete<any>(`/training-types/${id}`);

const trainingTypeApi = {
  getTrainingTypes,
  create,
  update,
  remove,
};
export default trainingTypeApi;
